<template>
  <div class="row">
    <div class="col-12">
      <b-form-group :label="label">
        <small class="hint">{{ hint }}</small>
        <div class="d-flex gap-10">
          <div v-for="(f, i) in filesThumbnail" :key="i" class="image-preview" :class="classes">
            <img
              :style="customStyle" @click="previewImage(f)"
              :src="f.original_url"
              @error="$event.target.src = defaultThumb" alt=""
            />

            <x-icon
              v-if="enableRemoveMedia"
              size="1x"
              @click="onRemove(f)"
              class="x-icon"
            />

            <!--                        <span v-if="f.name" class="file-name">{{ f.name }}</span>-->
            <div v-if="f.progress > 1 && f.progress <= 100 && !f.id" class="progress-style">
              <BProgress :value="f.progress" max="100" />
            </div>
            <div v-if="f.error" v-html="f.error" class="bg-danger progress-style"></div>
            <!--                        <div v-if="f.progress ===100 && f.id" class="bg-success progress-style">-->
            <!--                            Done-->
            <!--                        </div>-->
          </div>
          <div :class="classes" v-show="localFilesCount < maxFiles">
            <vue2-dropzone
              :useCustomSlot="true"
              ref="myVueDropzone"
              class="my-dropzone"
              :style="customStyle"
              id="dropzone"
              :options="dropzoneOptions"
              @vdropzone-upload-progress="reflectProgress"
              @vdropzone-success="vsuccess"
              @vdropzone-error="vdropzoneError"
              @vdropzone-file-added="vfileAdded"
              @vdropzone-max-files-reached="maxSizeError"
            >
              <div class="dropzone-custom-title">
                <img :style="placeholderImgStyle" :src="defaultImage()" alt="" />
              </div>
            </vue2-dropzone>
          </div>
        </div>
      </b-form-group>
    </div>
    <b-modal
      id="preview-img"
      hide-header
      hide-footer
      v-model="modalState"
      centered
      @show="showModal"
      @hidden="hideModal"
    >
      <img v-if="selectedImage" class="w-100" :src="selectedImage.original_url" alt="">
    </b-modal>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import { XIcon } from "vue-feather-icons"
import store from "../store"

export default {
  name: "DropZone",
  components: {
    vue2Dropzone,
    XIcon
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    labelCols: {
      type: Number | String,
      default: 0
    },
    hint: {
      type: String,
      default: ""
    },
    classes: {
      type: String,
      default: ""
    },
    withNotes: {
      type: Boolean,
      default: false
    },
    filesThumbnail: {
      type: Array,
      default: () => []
    },
    customStyle: {
      default: "width:150px;height:175px",
      type: String
    },
    filesIDs: {
      type: Array,
      default: () => []
    },
    maxFiles: {
      type: Number,
      default: 10
    },
    maxSize: {
      type: Number,
      default: 30
    },
    endpoint: {
      default: "/api/upload-media",
      type: String
    },
    queryParam: {
      default: "",
      type: String
    },
    acceptedFiles: {
      default: "image/*",
      type: String
    },
    placeholderImgStyle: {
      default: "width:72px",
      type: String
    },
    enableRemoveMedia: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    filesThumbnail() {
      this.localFilesCount = this.filesThumbnail.length
    }
  },
  data() {
    return {
      localFilesCount: 0,
      dropzoneOptions: {
        timeout: 1000000,
        url: window.location.origin + this.endpoint + (this.queryParam ? "?" + this.queryParam : ""),
        // thumbnailWidth: 150,
        paramName: "files[]",
        maxFiles: this.maxFiles,
        acceptedFiles: this.acceptedFiles,
        maxFilesize: this.maxSize, // MB
        headers: {}
      },
      defaultThumb: this.defaultImage(),
      modalState: false,
      selectedImage: null
    }
  },
  methods: {
    showModal() {
    },
    previewImage(f) {
      this.modalState = true
      this.selectedImage = f
    },
    hideModal() {
      this.modalState = false
      this.selectedImage = null
    },
    defaultImage() {
      return `modules/product/images/Vector.svg`
    },
    getCookie(name) {
      const cookies = document.cookie.split(";")
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim()
        if (cookie.startsWith(name + "=")) {
          return decodeURIComponent(cookie.substring(name.length + 1))
        }
      }
      return null
    },
    vfileAdded(file) {
      const reader = new FileReader()
      const myFile = {}
      let fileStatus = null
      if (this.maxFiles <= this.localFilesCount) {
        this.$refs.myVueDropzone.removeFile(file)
        fileStatus = "Max files limit reached!"
      }
      this.localFilesCount++
      if (file.type.includes("image")) {
        const maxSize = this.maxSize
        setTimeout(() => {
          reader.addEventListener(
            "load",
            function() {
              // convert image file to base64 string
              myFile.original_url = reader.result
              myFile.progress = 1
              myFile.id = null
              myFile.error =
                file.status === "error"
                  ? file.upload.total > maxSize * 1024
                    ? `large file!<br>Max size ${maxSize}MB`
                    : fileStatus
                  : fileStatus
            },
            false
          )
          reader.readAsDataURL(file)
          setTimeout(() => {
            this.filesThumbnail.push(myFile)
          }, 50)
        }, 50)
      } else {
        const test = {
          original_url: this.defaultImage(),
          progress: 1,
          id: null,
          // error: file.status === 'error' ? `${Index.t('large file!')}<br>${Index.t('Max size 4MB')}` : null,
          error:
            file.status === "error"
              ? file.upload.total > 36700000
                ? `large file!<br>Max size 35MB`
                : fileStatus
              : fileStatus,
          name: file.name,
          size: file.size
        }
        this.filesThumbnail.push(test)
      }
    },
    reflectProgress(file, progress, bytesSent) {
      this.filesThumbnail.map(f => {
        if (file.type.includes("image")) {
          if (f.original_url === file.dataURL) {
            f.progress = progress
          }
        } else {
          if (f.name === file.name && f.size === file.size) {
            f.progress = progress
          }
        }
      })
    },
    vsuccess(file, response) {
      this.filesThumbnail.map(f => {
        if (file.type.includes("image")) {
          if (f.original_url === file.dataURL) {
            f.id = response.data[0].media[0].id
            if (this.withNotes) {
              f.note = ""
              this.filesIDs.push({ file_id: response.data[0].media[0].id, note: "" })
            } else {
              this.filesIDs.push(response.data[0].media[0].id)
            }
            this.$emit("dataChanged", this.filesIDs)
          }
        } else {
          if (f.name === file.name && f.size === file.size) {
            f.id = response.data[0].media[0].id
            if (this.withNotes) {
              f.note = ""
              this.filesIDs.push({ file_id: response.data[0].media[0].id, note: "" })
            } else {
              this.filesIDs.push(response.data[0].media[0].id)
            }
            this.$emit("dataChanged", this.filesIDs)
          }
        }
      })
    },
    maxSizeError(files) {
      //   console.error('maxSizeError', files)
      //   this.filesThumbnail.map(f => {
      //     files.forEach(file => {
      //       if (file.type.includes('image')) {
      //         if (f.original_url === file.dataURL) {
      //           console.warn('Max limit reached')
      //           f.error = Index.t('Max limit reached')
      //         }
      //       } else {
      //         if (f.name === file.name && f.size === file.size) {
      //           f.error = Index.t('Max limit reached')
      //         }
      //       }
      //     })
      //
      //   })
    },
    vdropzoneError(file, message) {
      console.log(message)
      if (this.filesThumbnail.length === 1) {
        this.filesThumbnail[0].error = message.message ?? message
      }
      this.filesThumbnail.map(f => {
        if (file.type.includes("image")) {
          if (f.original_url === file.dataURL) {
            f.error = message
          }
        } else {
          if (f.name === file.name && f.size === file.size) {
            f.error = message
          }
        }
      })
    },
    noteChanged(event, file) {
      this.filesIDs.forEach(fileObj => {
        if (fileObj.file_id === file.id) {
          fileObj.note = event
        }
      })
      this.$emit("dataChanged", this.filesIDs)
    },
    onRemove(file) {
      this.localFilesCount--
      this.filesThumbnail.splice(this.filesThumbnail.indexOf(file), 1)
      this.$refs.myVueDropzone.dropzone.files.splice(this.$refs.myVueDropzone.dropzone.files.indexOf(file), 1)
      if (this.withNotes) {
        const onlyIds = this.filesIDs
        if (onlyIds.map(e => e.file_id).indexOf(file.id) !== -1) {
          this.filesIDs.splice(onlyIds.map(e => e.file_id).indexOf(file.id), 1)
        }
      } else {
        if (this.filesIDs.indexOf(file.id) !== -1) {
          this.filesIDs.splice(this.filesIDs.indexOf(file.id), 1)
        }
      }
      this.$emit("dataChanged", this.filesIDs)
    }
  },
  mounted() {
    this.localFilesCount = this.filesThumbnail.length
    this.dropzoneOptions.headers["X-XSRF-TOKEN"] = this.getCookie("XSRF-TOKEN")
  }
}
</script>

<style scoped>
/*@media (max-width: 1200px ) {*/
/*  .my-dropzone, .image-preview img{*/
/*    height: 100px;*/
/*  }*/
/*}*/
.bg-success {
  background: var(--primary) !important;
}

/*@media (max-width: 1281px) and  (min-width: 1200px) {*/
/*    .my-dropzone, .image-preview img {*/
/*        height: 90px;*/
/*    }*/
/*}*/

/*@media (max-width: 900px ) {*/
/*    .my-dropzone, .image-preview img {*/
/*        height: 80px;*/
/*    }*/
/*}*/
</style>
<style>
.dropzone .dz-message {
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex !important;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background: transparent;
}

.dropzone .dz-message .dropzone-custom-title {
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  right: 0;
  justify-content: center;
  align-items: center;
}

.dropzone .dz-preview {
  position: absolute !important;
  z-index: -10;
}

.image-preview {
  margin-bottom: 5px;
  /*margin-right: 1rem;*/
  position: relative;
  border-radius: 6px;
}

.image-preview img {
  /*width: 150px;*/
  /*height: 175px;*/
}

.image-preview svg {
  position: absolute;
  right: 2px;
  top: 2px;
  z-index: 99;
  background: #eee;
  padding: 0.3rem;
  border-radius: 20px;
  font-size: 10px;
  display: none;
  cursor: pointer;
}

.image-preview:hover svg {
  display: block;
}

.image-preview img {
  position: relative;
  cursor: pointer;
  object-fit: contain;
  border-radius: 6px;
}

.image-preview img:hover {
  opacity: 0.7;
}

.image-preview:hover .file-name {
  z-index: 1;
}

.file-name {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  word-break: break-word;
  color: #fff;
  font-size: 12px;
  padding: 4px;
  width: 175px;
  background: rgba(128, 128, 128, 0.85);
  height: 100px;
  border-radius: 6px;
}

.progress-style {
  bottom: 0;
  border-radius: 6px;
  position: absolute;
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: #fff;
  z-index: 4;
}

.my-dropzone {
  display: flex;
  align-items: center;
  position: relative;
  min-height: unset;
  /*width: 150px;*/
  /*height: 175px;*/
  background: transparent;
  cursor: pointer;
  border: 1px solid #b5b5b5;
  color: #717386;
  font-size: 14px;
  overflow: hidden;
  border-radius: 5px !important;
  margin-bottom: 0 !important;
}

/*.my-dropzone img {*/
/*    width: 5rem;*/
/*    display: flex;*/
/*}*/

.hint {
  font-size: 11px;
  color: var(--gray);
  display: flex;
  margin-bottom: 0.5rem;
  margin-top: -0.2rem;
}

.x-icon {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
